<template>
  <RouterView></RouterView>
</template>

<script setup>
// import { useCommon } from './assets/js/store/modules/resCommon';
// const useCommons = useCommon();
</script>

